// NextBlock is free since Sep 2026. Existing paid subscriptions keep running (and can be cancelled),
// so payment UI is only shown to users who still have one. The backend decides who that is.

const WALLET_BALANCE = 2;

export const hasPaidSubscription = (user) => Boolean(user && user.has_paid_subscription);

// Users with an active paid subscription, or leftover balance they should still be able to see.
export const showBalance = (user) => Boolean(user && user.show_balance);

// Only wallet-balance subscribers that still renew need to top up (renewals are paid from the balance).
export const canTopUp = (user) =>
  hasPaidSubscription(user) &&
  user.payment_method_id === WALLET_BALANCE &&
  user.unsubscribed_since == null;
